import { useContext, useEffect } from "react";
import AddQueryParamsToURL from "@beeldit/core/helpers/AddQueryParamsToURL";
import useFilters from "@beeldit/core/helpers/useFilters";
import BeelditTableFilters from "@beeldit/core/components/BeelditTableFilters";
import { ListActionContext } from "./ListActionContext";
import useIndex from "./useIndex";

function useListAction(modelConfig: any, user: any, filters: any = {}): any {
  const addQueryParamsToURL: any = AddQueryParamsToURL();

  /** Crud functions */
  const index = useIndex(modelConfig);
  const indexFunction = () => index();

  /** Filter loading */
  const { tableFilters, setTableFilters } = useContext(ListActionContext);
  const { tableConfig, setTableConfig } = useContext(ListActionContext);
  useFilters({ ...{}, ...filters }, ListActionContext);

  /**
   * Pagination config
   */
  const { paginationConfig } =
    useContext(ListActionContext);

  /** Index table funcion definition */
  const { tableData } = useContext(ListActionContext);

  useEffect(() => {
    index();
  }, [tableFilters, paginationConfig]);

  /**<newActionsFunctions>**/

  /** Table Filters configuration */
  const filterUIConfig = modelConfig.filterUIConfig;
  const filterConfig = {
    schema: modelConfig.filterConfig,
    uiSchema: filterUIConfig.uiScheme,
    widgets: filterUIConfig.widgets,
    element: tableFilters,
    onChange: (form: any) => {
      setTableFilters(form.formData);
      addQueryParamsToURL(form.formData);
    },
  };

  let actionTemplate = tableConfig ? (
    <>
      <BeelditTableFilters formConfig={filterConfig} />
      {/* <BeelditModelTable
          tableData={tableData}
          tableConfig={tableConfig}
          onOrderByChange={onOrderByChange}
        />
        <BeelditTablePagination
          paginationConfig={paginationConfig}
          totalElements={tableData.totalElements}
          onPaginationChange={onPaginationChange}
        ></BeelditTablePagination> */}
    </>
  ) : (
    <>table config: {!tableConfig}</>
  );
  /** END EDIT TABLE ACTION */

  return {
    indexFunction,
    actionTemplate,
    setTableConfig,
    setTableFilters
  };
}

export default useListAction;
